import { render, staticRenderFns } from "./aPricingStrategyGuardrails.vue?vue&type=template&id=564628f6&scoped=true"
import script from "./aPricingStrategyGuardrails.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyGuardrails.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyGuardrails.vue?vue&type=style&index=0&id=564628f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564628f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
